import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import Dashboard from './pages/Dashboard';
import AdminDashboard from './admin/AdminDashboard';
import Header from './components/Header';
import { useState, useEffect } from 'react';
import api from './utils/api';
import ContactPage from './pages/ContactPage';

function App() {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);

    useEffect(() => {
        const userId = localStorage.getItem('userId');
        if (userId) {
            setIsLoggedIn(true);
            const fetchUserRole = async () => {
                try {
                    const response = await api.get(`/users/${userId}`);
                    setIsAdmin(response.data.isAdmin);
                } catch (err) {
                    console.error('Failed to fetch user role:', err);
                }
            };
            fetchUserRole();
        }
    }, []);

    const handleLogout = () => {
        localStorage.removeItem('userId');
        setIsLoggedIn(false);
        setIsAdmin(false);
        window.location.href = '/';
    };

    return (
        <Router>
            <div className="App">
                <Header isLoggedIn={isLoggedIn} isAdmin={isAdmin} handleLogout={handleLogout} />
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/contact" element={<ContactPage />} />
                    <Route path="/login" element={<LoginPage setIsLoggedIn={setIsLoggedIn} setIsAdmin={setIsAdmin} />} />
                    <Route path="/register" element={<RegisterPage />} />
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/admin/dashboard" element={<AdminDashboard />} />
                </Routes>
            </div>
        </Router>
    );
}

export default App;